<template>
    <div class="google-map-itinerary">
        <TripPlanner class="trip-planner-form" />
    </div>
</template>

<script setup>
import TripPlanner from '@/shared/TripPlanner';
</script>

<style lang="scss" scoped>
.google-map-itinerary {
    background-color: $color-white;
    border-radius: 20px;
    @include breakpoint(large) {
        padding: 16px;
    }
}
.trip-planner-form {
    max-width: 550px;
}
</style>
